import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

interface Props {
  children: ReactNode;
  module?: string;
}

export function RequireAuth({ children, module }: Props) {
  const { user, loading, hasPerm } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-[var(--text-muted)]">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if (module && !hasPerm(module)) {
    return (
      <div className="rounded-card border border-danger/40 bg-danger/10 p-6 text-sm text-danger">
        You don&apos;t have permission to view this page.
      </div>
    );
  }
  return <>{children}</>;
}
